import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class MapaCirurgico extends CoreBase implements IMapaCirurgico {
  async getSolicitacoesMapaCirurgico(param: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getSolicitacoesMapaCirurgico(param)
    return response
  }

  async criarMapaCirurgico(data: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.criarMapaCirurgico(data)
    return response
  }

  async excluirSolicitacaoMapaCirurgico(data: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.excluirSolicitacaoMapaCirurgico(data)
    return response
  }

  async areaMapaCirurgicoConfirmaSolicitacao(data: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.areaMapaCirurgicoConfirmaSolicitacao(data)
    return response
  }

  async cirurgiaRealizada(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.cirurgiaRealizada(params)
    return response
  }
}

interface IMapaCirurgico extends ICoreBase {
  getSolicitacoesMapaCirurgico(param: any): Promise<ResponseApi>
  criarMapaCirurgico(data: any): Promise<ResponseApi>
  excluirSolicitacaoMapaCirurgico(data: any): Promise<ResponseApi>
  areaMapaCirurgicoConfirmaSolicitacao(data: any): Promise<ResponseApi>
  cirurgiaRealizada(data: any): Promise<ResponseApi>
}

export {
  MapaCirurgico,
  IMapaCirurgico,
}
